var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, Form, actions as formActions } from 'react-redux-form';

import debounce from "../../utils/debounce";
import { t } from "../../I18N";
import { Icon } from "../../UI";

import { searchReferences } from "../actions/actions";

export class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.changeSearchTerm = debounce(this.props.searchReferences, 400);
  }

  componentDidUpdate(prevProps) {
    if (this.props.entityId !== prevProps.entityId) {
      this.resetSearchTerm();
    }
  }

  componentWillUnmount() {
    this.resetSearchTerm();
  }

  resetSearchTerm() {
    this.props.change('relationships/list/search.searchTerm', '');
  }

  resetSearch() {
    this.resetSearchTerm();
    this.props.searchReferences();
  }

  render() {
    const { search } = this.props;
    const searchTerm = search.searchTerm && search.searchTerm.value ? search.searchTerm.value : '';

    return /*#__PURE__*/(
      _jsx("div", { className: "search-box" }, void 0, /*#__PURE__*/
      _jsx(Form, {
        model: "relationships/list/search",
        onSubmit: this.props.searchReferences,
        autoComplete: "off" }, void 0, /*#__PURE__*/

      _jsx("div", { className: `input-group${searchTerm ? ' is-active' : ''}` }, void 0, /*#__PURE__*/
      _jsx(Field, { model: "relationships/list/search.searchTerm" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "search" }), /*#__PURE__*/
      _jsx("input", {
        type: "text",
        placeholder: t('System', 'Search related entities or documents', null, false),
        className: "form-control",
        onChange: this.changeSearchTerm.bind(this),
        autoComplete: "off",
        value: searchTerm }
      ), /*#__PURE__*/
      _jsx(Icon, { icon: "times", onClick: this.resetSearch.bind(this) })
      )
      )
      )
      ));

  }
}








export function mapStateToProps({ relationships }) {
  const { entityId, search } = relationships.list;
  return {
    entityId,
    search
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchReferences,
      change: formActions.change
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);